import React, { useState, useEffect } from 'react'
import { IonAccordion, IonAccordionGroup, IonBadge, IonButton, IonCard, IonContent, IonIcon, IonItem, IonLabel, IonList, IonRadio, IonRadioGroup, IonRow } from '@ionic/react'
import { caretDown, eye, lockOpen, people } from 'ionicons/icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import { SafetyPadding } from '../../components/SafetyPadding';
import Api from '../../services/Api';

interface ComponentProps {
  handleNetwork: Function
  teamId: Number | null
  slideNext: Function
  cancelCreate: Function
}

const CreateNetworkPicker = ({ handleNetwork, teamId, slideNext, cancelCreate }: ComponentProps) => {
  const api = Api.getInstance()
  const network = useSelector((state: RootState) => state.logIn.user.teams)
  const [pickedNetwork, setPickedNetwork] = useState<Number | null>(null)

  useEffect(() => {
    if(pickedNetwork === null && teamId !== null) {
      setPickedNetwork(teamId)
    }
  }, [])

  useEffect(() => {
      handleNetwork(pickedNetwork)
  }, [pickedNetwork])

  const changeNetwork = (value: Number | null) => {
    setPickedNetwork(value)
  }

  return (
    <IonContent>
      <h2 className="color_blue text_center m-4">
        {api.tr('Visible_network')}
      </h2>
      <IonCard className="p-2 m-2">
      <IonList>
        <IonRadioGroup value={teamId ? teamId : 'null'}>
        <IonRow className="p-2 flex items-center">
          <IonIcon icon={lockOpen} className="mr-2" size="large" color="darkblue"/>
          <h2 className="color_blue">{api.tr('Visible_network_Public')}</h2>
        </IonRow>
        <IonItem>
          <IonBadge class="p-2" slot="start" color="darkblue">{api.tr('Visible_publicButton')}</IonBadge>
          <IonLabel className="ml-2">{api.tr('Visible_network_Open')}</IonLabel>
          <IonRadio value="null" slot="end" color="primary"
            onClick={() => changeNetwork(null)}/>
        </IonItem>
        <IonAccordionGroup value="first" className="mt-4">
          <IonAccordion value="first" toggleIcon={caretDown} toggleIconSlot="end" color="dark">
            <IonItem color="light" slot="header">
              <IonIcon  icon={eye} className="mr-2" size="large" color="darkblue"/>
              <h2 className="color_blue">{api.tr('Visible_network_my')}</h2>
            </IonItem>
            <div slot="content">
            { network.map((team: any, key: any) => <IonItem key={'networkpicker' + key}>
              {/* <IonBadge slot="start" class="p-2" color="darkblue">
                <IonIcon icon={people}/>
                {team.teamMembers.length}
              </IonBadge>  */}
              <IonLabel className="ml-2">{team.teamName}</IonLabel>
              <IonRadio value={team.teamId} slot="end" 
                onClick={() => changeNetwork(team.teamId)}/>
            </IonItem>) }
            </div>
          </IonAccordion>
        </IonAccordionGroup>
      </IonRadioGroup>
      </IonList>
      </IonCard>
      <IonRow className="mt-6">
        <IonButton 
          onClick={() => slideNext()}
          expand="block" 
          className="m-2 fullWidth">
          {api.tr('ContinueNext_page')}
        </IonButton>
      </IonRow>
      <IonRow>
        <IonButton 
          color="danger"
          onClick={() => {
            cancelCreate()
          }}
          expand="block" 
          fill="clear"
          className="m-2 fullWidth">
          {api.tr('cancel')}
        </IonButton>
      </IonRow>
      <SafetyPadding/>
    </IonContent>
  )
}

export default CreateNetworkPicker